import React from 'react';
import RowActionsMenu from '../shared/RowActionsMenu';
import Icon from '../shared/Icon';
import { isThreadShared } from './sharedQueries';

/**
 * Three-dot "Query actions" menu on a Saved queries row (PRD-1571 R1, R5).
 *
 * The owner gets Edit, Share (or "Sharing settings" once shared) and Delete.
 * Anyone else gets no menu: "Remove from my list" was dropped (PRD-1650).
 * Share is offered only when the host passes `onShare`.
 */
function ThreadRowMenu({ thread, isOwner, onEdit, onShare, onDelete }) {
  if (!isOwner) return null;
  return (
    <RowActionsMenu ariaLabel="Query actions">
      {(close) => (
        <>
          <button onClick={() => { close(); onEdit(thread); }}>
            <Icon name="edit" /> Edit
          </button>
          {onShare && (
            <button onClick={() => { close(); onShare(thread); }}>
              <Icon name="groups" /> {isThreadShared(thread) ? 'Sharing settings' : 'Share'}
            </button>
          )}
          <button className="row-actions-menu-danger" onClick={() => { close(); onDelete(thread); }}>
            <Icon name="delete" /> Delete
          </button>
        </>
      )}
    </RowActionsMenu>
  );
}

export default ThreadRowMenu;
